/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-release-off': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M17.967 10.86a.355.355 0 0 0-.32-.193h-4.182l4.128-6.155a.317.317 0 0 0 .01-.34.357.357 0 0 0-.309-.172h-5.647a.356.356 0 0 0-.316.184l-5.294 10a.317.317 0 0 0 .016.324.358.358 0 0 0 .3.159h3.63l-3.955 8.87a.325.325 0 0 0 .14.414.367.367 0 0 0 .455-.07l11.294-12.666a.32.32 0 0 0 .05-.356z" _fill="#CBD4D8"/>'
  }
})
